(() => {
  const roots = document.querySelectorAll('[data-bulk-market]');
  roots.forEach((root) => {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('plainjane-bulk-market--motion-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
      root.querySelectorAll('[data-bulk-reveal]').forEach((element) => observer.observe(element));
    }

    root.querySelectorAll('[data-bulk-grade]').forEach((grade) => {
      const track = grade.querySelector('[data-bulk-track]');
      const previous = grade.querySelector('[data-bulk-previous]');
      const next = grade.querySelector('[data-bulk-next]');
      if (!track || !previous || !next) return;

      const updateButtons = () => {
        previous.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      const move = (direction) => track.scrollBy({ left: direction * track.clientWidth * .82, behavior: 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });
      updateButtons();
    });
  });
})();
